let env = process.env
const config = {
  BASE_URL: env.REACT_APP_BASE_URL,
  // PER_PAGE: parseInt(env.REACT_APP_PER_PAGE) || 10
  PER_PAGE: 10,
  B2B_SECRET_KEY: env.REACT_APP_B2B_SECRET_KEY,
  ACTUALCPM: +env.REACT_APP_ACTUALCPM,
  ACTUALCPC: +env.REACT_APP_ACTUALCPC,
  CSTUsers: env.REACT_APP_CSTUsers,
  AWS_BRAND_URL: env.REACT_APP_AWS_BRAND_URL,
  AWS_IMG_URL: env.REACT_APP_AWS_IMG_URL,
  AWS_COMMENT_AD_URL: env.REACT_APP_AWS_COMMENT_AD_URL,
  AWS_BRAND_AD_URL: env.REACT_APP_AWS_BRAND_AD_URL,
  CARDLIST_TEAMS: env.REACT_APP_CARDLIST_TEAMS,
  CUSTOM_ADVS: env.REACT_APP_CUSTOM_ADVS,
  HEADLINE: env.REACT_APP_HEADLINE,
  DESCRIPTION: env.REACT_APP_DESCRIPTION,
  VAPID_publicKey:env.REACT_APP_VAPID_PUBLIC_KEY,
  APP_URL_PREFIX:env.REACT_APP_URL_PREFIX,
  DEVS : env.REACT_APP_DEVS || [],
  MAIN_CROP_RATIO : env.REACT_APP_MAIN_CROP_RATIO,
  OTHER_CROP_RATIO : env.REACT_APP_OTHER_CROP_RATIO,
  SAKSHI_CROP_RATIO : env.REACT_APP_SAKSHI_CROP_RATIO,
  SALES_EMAILS_B2B_REPORTS:env.REACT_APP_SALES_EMAILS_B2B_REPORTS || [],
  ALPHA_SOCKET_URL : env.REACT_APP_ALPHA_SOCKET_URL || "",
  // Order-booking API origin — the shared creative-chat realtime hub.
  // NOT the ads panel's own API (BASE_URL). See docs/booking-creative-chat.md.
  // Two consumers currently point at this same hub with two separate config
  // shapes (bookingChatSocket.js's single URL vs creativeChatSocket.js's
  // URL+path pair) — kept both as-is rather than unifying silently inside a
  // merge; worth a deliberate follow-up to consolidate.
  ORDER_BOOKING_URL : env.REACT_APP_ORDER_BOOKING_URL || "",
  ORDER_BOOKING_SOCKET_URL: env.REACT_APP_ORDER_BOOKING_SOCKET_URL || "",
  ORDER_BOOKING_SOCKET_PATH: env.REACT_APP_ORDER_BOOKING_SOCKET_PATH || "/socket.io",
  SALES_CST_ACCESS_EMAILS:env.REACT_APP_SALES_CST_ACCESS_EMAILS || [],
  ALPHA_SOCKET_URL : env.REACT_APP_ALPHA_SOCKET_URL || "",
  GOOGLE_CLIENT_ID : env.REACT_APP_GOOGLE_CLIENT_ID || "",
}
export default config